const ValidationWorkflowTypes = {
  CONFIGURATION: "configuration",
  VERIFY_TEMPLATE: "verify-template",
  CRM_ACCOUNTS: "crm-accounts",
  POWERPOINT_TEMPLATE: "powerpoint-template",
  BULK_USER_UPLOAD: "bulk-user-upload",
  AI_PROMPT_TEMPLATES: "ai-prompt-templates"
} as const;

const ALL = Object.values(ValidationWorkflowTypes);

export default { ...ValidationWorkflowTypes, ALL };
